import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function AggregationElectionCompleteStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "complete-heading", children: [_jsx("h3", { id: "complete-heading", children: t('aggregation.complete.heading') }), _jsx("p", { children: t('aggregation.complete.body_template', {
                    count: props.configs.length,
                    initiatedAt: props.initiatedFirstPullAt,
                }) }), _jsx("p", { children: _jsx("em", { children: t('aggregation.complete.next_steps') }) }), _jsx("button", { type: "button", onClick: props.onClose, children: t('aggregation.complete.close') })] }));
}
//# sourceMappingURL=election-complete-step.js.map